import type { ReactNode } from 'react';

/** Serif section title with its icon chip — shared by every block of the Info tab. */
export default function InfoSectionHeader({ icon, title }: { icon: ReactNode; title: string }) {
  return (
    <div className="flex items-center gap-3 mb-4">
      <span className="w-9 h-9 shrink-0 rounded-xl flex items-center justify-center bg-white dark:bg-slate-900 border border-slate-100 dark:border-slate-800 shadow-rim text-teal-600 dark:text-teal-400 text-lg leading-none">
        {icon}
      </span>
      <h3 className="font-serif text-xl leading-tight text-slate-900 dark:text-slate-100">{title}</h3>
    </div>
  );
}
